import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx";
import { DropTarget, DragDropContainer } from 'react-drag-drop-container';

class FieldDragDrop extends Component {
  render() {
    return (
      <DragDropContainer
        dragStartThreshold={10}
        noDragging={this.props.noDragging}
        onDrag={(data, target, x, y)=>{

        }}
        onDrop={()=>{
          this.props.dragLinker.value.active=false;
          document.getElementsByTagName('body')[0].classList.remove('grabbing');
        }}
        dragData={{ source:toJS(this.props.item) }}
        targetKey="general"
        onDragEnd={()=> {
          this.props.dragLinker.value.active = false;
          this.props.dragLinker.value.data = null;
          document.getElementsByTagName('body')[0].classList.remove('grabbing');
        }}
        onDragStart={()=> {
          this.props.dragLinker.value.active = true;
          this.props.dragLinker.value.data = toJS(this.props.item);
          document.getElementsByTagName('body')[0].classList.add('grabbing');
        }}
        elementProps={{ style:{ display:'block', position:'static'}}}
        returnToBase={true}
        dragClone={this.props.customDragElement?false:true}
        customDragElement={this.props.customDragElement}
        zIndex={22000}
      >
        {this.props.children}
      </DragDropContainer>
    )
  }
}

export default observer(FieldDragDrop);